import PropTypes from "prop-types";
import styles from "./svgicon.module.css";

export function SvgIcon({ Icon, invert = false }) {
  const iconStyles = `
    ${styles.container}
    ${invert ? styles.light : styles.dark}
    `;
  return (
    <div className={iconStyles}>
      <Icon />
    </div>
  );
}

SvgIcon.propTypes = {
  Icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired,
  invert: PropTypes.bool,
};
